"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getClassName = getClassName;
exports.topBorderStyle = exports.leftBorderStyle = exports.activeCellStyle = exports.highlightedCellStyle = exports.inactiveCellStyle = exports.cellStyle = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var colors = _interopRequireWildcard(require("@cimpress/react-components/lib/colors"));

var _emotion = require("emotion");

var cellStates = _interopRequireWildcard(require("../cellStates"));

function _templateObject6() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  border-top-style: solid;\n  border-top-width: 1px;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  border-left-style: solid;\n  border-left-width: 1px;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  ", "\n  background-color: ", ";\n  border-color: ", ";\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  ", "\n  background-color: ", ";\n  border-color: ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  ", "\n  background-color: ", ";\n  border-color: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n  height: 30px;\n  justify-content: center;\n  outline: none;\n  padding: 0 11px;\n  user-select: none;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var infoLighter = '#cbeaf5';
var cellStyle = (0, _emotion.css)(_templateObject());
exports.cellStyle = cellStyle;
var inactiveCellStyle = (0, _emotion.css)(_templateObject2(), cellStyle, colors.white, colors.platinum);
exports.inactiveCellStyle = inactiveCellStyle;
var highlightedCellStyle = (0, _emotion.css)(_templateObject3(), cellStyle, infoLighter, colors.info.base);
exports.highlightedCellStyle = highlightedCellStyle;
var activeCellStyle = (0, _emotion.css)(_templateObject4(), cellStyle, colors.white, colors.info.base);
exports.activeCellStyle = activeCellStyle;
var leftBorderStyle = (0, _emotion.css)(_templateObject5());
exports.leftBorderStyle = leftBorderStyle;
var topBorderStyle = (0, _emotion.css)(_templateObject6());
exports.topBorderStyle = topBorderStyle;

function getClassName(columnIndex, rowIndex, mode) {
  var _borderStyles;

  var borderStyles = (_borderStyles = {}, (0, _defineProperty2.default)(_borderStyles, leftBorderStyle, columnIndex > 0), (0, _defineProperty2.default)(_borderStyles, topBorderStyle, rowIndex > 0), _borderStyles);

  if (mode === cellStates.active || mode === cellStates.editing) {
    return (0, _emotion.cx)(activeCellStyle, borderStyles);
  }

  if (mode === cellStates.highlighted) {
    return (0, _emotion.cx)(highlightedCellStyle, borderStyles);
  }

  return (0, _emotion.cx)(inactiveCellStyle, borderStyles);
}